<script setup lang="ts">
import type { ReleaseNote } from '../domain/releaseNote';

const model = defineModel<ReleaseNote>({ required: true });

</script>

<template>
  <div v-html="model.html" class="prose release-note"></div>
</template>

<style scoped>

.p-dark .release-note {
  color: var(--p-surface-300);
  --tw-prose-headings: var(--p-surface-200);
}

</style>
